<div class="user-info">
	<div class="info-block user-exist" *ngIf="participant">
		<div class="user-block">
			<div class="avatar-block">
				<div class="word-avatar" style.background-color="#{{participant.user.bgColor}}">
					<div class="short-name">
						{{participant.user.shortCode}}
					</div>
				</div>
			</div>
			<div class="name-info">
				<div class="name">
					{{participant.user.name}}
				</div>
				<div class="phone">
					{{participant.user.email}}
				</div>
				<div class="phone">
					{{participant.user.phone}}
				</div>
			</div>
		</div>
		<div class="remove-button">
			<button mat-button (click)="removeUser()" *ngIf="project.projectManager?.username !== participant.user.username">Detach Member</button>
			<div class="manager-div" *ngIf="project.projectManager?.username === participant.user.username">Project Manager</div>
		</div>
	</div>
</div>